import { render, staticRenderFns } from "./GeneralInfoReport.vue?vue&type=template&id=ad090aaa&scoped=true"
import script from "./GeneralInfoReport.vue?vue&type=script&lang=js"
export * from "./GeneralInfoReport.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfoReport.vue?vue&type=style&index=0&id=ad090aaa&prod&scoped=true&lang=css"
import style1 from "./GeneralInfoReport.vue?vue&type=style&index=1&id=ad090aaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad090aaa",
  null
  
)

export default component.exports